/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as SelectDefault } from './select-default.story';
export { default as SelectErrorState } from './select-error-state.story';
export { default as SelectCreatable } from './select-creatable.story';
export { default as SelectMulti } from './select-multi.story';
export { default as SelectCustomLabel } from './select-custom-label.story';
export { default as SelectInsideDialog } from './select-inside-dialog.story';
export { default as SelectDisabled } from './select-disabled.story';
export { default as SelectClean } from './select-clean.story';
export { default as SelectSizes } from './select-sizes.story';
export { default as SelectMenuPositionings } from './select-menu-positionings.story';
export { default as SelectAsync } from './select-async.story';
export { default as SelectControlled } from './select-controlled.story';
export { default as SelectEmpty } from './select-empty.story';
export { default as SelectRequired } from './select-required.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import SelectAsyncSourceRaw from './select-async.story?raw';
import SelectCleanSourceRaw from './select-clean.story?raw';
import SelectControlledSourceRaw from './select-controlled.story?raw';
import SelectCreatableSourceRaw from './select-creatable.story?raw';
import SelectCustomLabelSourceRaw from './select-custom-label.story?raw';
import SelectDefaultSourceRaw from './select-default.story?raw';
import SelectDisabledSourceRaw from './select-disabled.story?raw';
import SelectEmptySourceRaw from './select-empty.story?raw';
import SelectErrorStateSourceRaw from './select-error-state.story?raw';
import SelectInsideDialogSourceRaw from './select-inside-dialog.story?raw';
import SelectMenuPositioningsSourceRaw from './select-menu-positionings.story?raw';
import SelectMultiSourceRaw from './select-multi.story?raw';
import SelectRequiredSourceRaw from './select-required.story?raw';
import SelectSizesSourceRaw from './select-sizes.story?raw';

export const SelectDefaultSource = removeLicenseHeader(SelectDefaultSourceRaw);
export const SelectErrorStateSource = removeLicenseHeader(
  SelectErrorStateSourceRaw,
);
export const SelectCreatableSource = removeLicenseHeader(
  SelectCreatableSourceRaw,
);
export const SelectMultiSource = removeLicenseHeader(SelectMultiSourceRaw);
export const SelectCustomLabelSource = removeLicenseHeader(
  SelectCustomLabelSourceRaw,
);
export const SelectInsideDialogSource = removeLicenseHeader(
  SelectInsideDialogSourceRaw,
);
export const SelectDisabledSource = removeLicenseHeader(
  SelectDisabledSourceRaw,
);
export const SelectCleanSource = removeLicenseHeader(SelectCleanSourceRaw);
export const SelectSizesSource = removeLicenseHeader(SelectSizesSourceRaw);
export const SelectMenuPositioningsSource = removeLicenseHeader(
  SelectMenuPositioningsSourceRaw,
);
export const SelectAsyncSource = removeLicenseHeader(SelectAsyncSourceRaw);
export const SelectControlledSource = removeLicenseHeader(
  SelectControlledSourceRaw,
);
export const SelectEmptySource = removeLicenseHeader(SelectEmptySourceRaw);
export const SelectRequiredSource = removeLicenseHeader(
  SelectRequiredSourceRaw,
);
